import { css, styled } from "../../../../../../styles";

export const articlePickerModalCss = css({
  ".ant-modal-content": {
    padding: "0 !important",
    borderRadius: "8px !important",
    overflow: "hidden",
  },
  ".ant-modal-header": {
    padding: "20px 24px 12px 24px !important",
    margin: "0 !important",
    borderBottom: "1px solid $gray-30",
  },
  ".ant-modal-title": {
    fontFamily: "$openSans !important",
    fontSize: "$text-xl !important",
    fontWeight: "500 !important",
    color: "$black !important",
  },
  ".ant-modal-body": {
    padding: "0 !important",
  },
  ".ant-modal-close": {
    top: "16px !important",
    right: "16px !important",
    width: "28px !important",
    height: "28px !important",
    display: "flex !important",
    alignItems: "center !important",
    justifyContent: "center !important",
    borderRadius: "50% !important",
    transition: "background-color 120ms ease",
  },
  ".ant-modal-close:hover": {
    backgroundColor: "$gray-30 !important",
  },
  ".ant-modal-close-x": {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    width: "16px",
    height: "16px",
    lineHeight: 1,
  },
});

export const Container = styled("div", {
  display: "flex",
  flexDirection: "column",
  width: "560px",
  maxWidth: "100%",
});

export const SearchContainer = styled("div", {
  padding: "16px 24px 8px 24px",
});

export const ListContainer = styled("div", {
  display: "flex",
  flexDirection: "column",
  maxHeight: "360px",
  minHeight: "120px",
  overflowY: "auto",
  padding: "0 0 8px 0",
});

export const ArticleRow = styled("button", {
  all: "unset",
  display: "flex",
  alignItems: "center",
  gap: "12px",
  padding: "10px 24px",
  cursor: "pointer",
  fontFamily: "$openSans",
  fontSize: "$text-md",
  color: "$black",
  lineHeight: "22px",
  borderLeft: "3px solid transparent",

  "&:hover": {
    backgroundColor: "$gray-20",
  },

  "&:focus-visible": {
    backgroundColor: "$gray-20",
    outline: "none",
  },

  variants: {
    selected: {
      true: {
        backgroundColor: "$gray-30",
        borderLeftColor: "$primary-30",
        fontWeight: 600,
      },
    },
  },
});

export const EmptyState = styled("div", {
  display: "flex",
  flexDirection: "column",
  alignItems: "center",
  justifyContent: "center",
  padding: "32px 24px",
  gap: "8px",
  color: "$gray-90",
  fontFamily: "$openSans",
  fontSize: "$text-md",
  textAlign: "center",
});

export const LoadingState = styled("div", {
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  padding: "32px 24px",
  color: "$gray-90",
  fontFamily: "$openSans",
  fontSize: "$text-md",
});

export const Footer = styled("div", {
  display: "flex",
  justifyContent: "flex-end",
  gap: "16px",
  padding: "16px 24px",
  borderTop: "1px solid $gray-30",
});

export const CancelButton = styled("button", {
  all: "unset",
  cursor: "pointer",
  fontFamily: "$openSans",
  fontSize: "$text-lg",
  fontWeight: 600,
  color: "$black",
  padding: "0 12px",
  height: "$13",
  display: "flex",
  alignItems: "center",
});
